import React from 'react';
import { Card, Box, Typography, Divider, Grid } from '@mui/material';

export default function VendorPayments({ validityExpiring = 2, pending = 1, overdue = 1 }) {
  return (
    <>
      <Box
        sx={{
          display: 'inline-block',
          px: 2.5,
          py: 1,
          borderRadius: 1,
          mb: 1,
          backgroundColor: '#F6F9FF',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.08)'
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: '14px', lineHeight: '14px' }}>
          Vendor Payments
        </Typography>
      </Box>
      <Typography sx={{ fontSize: '25px', fontWeight: 700, fontFamily: 'Montserrat', color: "#FF3C00" }}>{validityExpiring}</Typography>
      <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>Validity Expiring</Typography>
      <Divider sx={{ my: 1.5, mx: 2 }} />
      <Grid container>
        <Grid size={{ xs: 6 }}>
          <Typography sx={{ fontSize: '25px', fontWeight: 700, fontFamily: 'Montserrat', color: "#FF1100" }}>
            {pending}
          </Typography>
          <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>Pending</Typography>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Typography sx={{  fontSize: '25px', fontWeight: 700, fontFamily: 'Montserrat', color: "#FFBB8C" }}>
            {overdue}
          </Typography>
          <Typography sx={{ fontSize: '14px', fontWeight: 700, }}>Overdue</Typography>
        </Grid>
      </Grid>
    </>
  );
}
